export default class SubscriptionEditController {
    constructor($routeParams, userService,  subscriptionService, $mdDialog, $location, notificationsService, auditService) {
        this.form = {};
        this.form.subscription = {}; //this could be nicer?      
        this.userService = userService;
        this.subscriptionService = subscriptionService;
        this.auditService = auditService;
        this.$location = $location;
        this.$mdDialog = $mdDialog;
        this.notificationsService = notificationsService;
        this.imageData = {};
        this.auditLogs = {};        


        this.auditService.getAuditsBySubscriptionId($routeParams.id).then(resp => {
            this.auditLogs = resp.data;
        }, error => {
            $location.path("/");
        });

        this.userService.getAdminBySubscriptionId($routeParams.id).then(resp => {
            this.form.id = resp.data.id;
            this.form.subscriptionname = resp.data.subscriptionName;
            this.form.subscriptionadminname = resp.data.subscriptionAdminName;
            this.form.subscriptionadminemail = resp.data.subscriptionAdminEmail;
            this.form.subscriptionid = resp.data.subscriptionId;
            this.form.password = resp.data.password;
            this.form.confirmpassword = resp.data.password;
            this.form.subscriptionenddate = resp.data.subscriptionEndDate;
            this.form.subscriptionstartdate = resp.data.subscriptionStartDate;
            this.form.imageType = resp.data.imageType;
            this.form.icon = resp.data.icon;
            this.form.creditstrainee = resp.data.creditsTrainee;
            this.form.creditscourse = resp.data.creditsCourse;
        }, error => {
            $location.path("/");
        });
    }

    onSave(){
        //admin user type
        this.form.usertype = 2;

        var that = this;

        that.form.image = that.imageData.image;
        that.form.imagetype = that.imageData.imagetype;

        that.userService.updateSubscriptionAdmin(that.form).then(resp => {
            that.$location.path("/subscriptions");

            that.notificationsService.show("Subscription updated", "success");
        }, resp => {
            that.notificationsService.show(resp.data, "error");
        });
    }

    deleteSubscription(){

        var that = this;
        
        that.subscriptionService.deleteSubscription(that.form.subscriptionid).then(resp => {
            that.$location.path("/subscriptions/");
            that.notificationsService.show("Subscription deleted", "success");
        });
    }


    showWarning(ev) {
        this.$mdDialog.show({
            contentElement: '#deleteSubscriptionDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };

    hideWarning(ev) {
        this.$mdDialog.hide({
            contentElement: '#deleteSubscriptionDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };
}


// WEBPACK FOOTER //
// ./src/js/components/subscriptions/subscriptions.edit.controller.js